import Rails from "@rails/ujs";
import * as ActionCable from "@rails/actioncable";
window.ActionCable = ActionCable;
import ReactOnRails from 'react-on-rails';
import * as ActiveStorage from "@rails/activestorage";
import "@hotwired/turbo-rails"
import "channels";
global.$ = require('jquery');
//= require actiontext

Rails.start();
ActiveStorage.start();

import "trix"
import "@rails/actiontext"

// Imports externes
import "bootstrap";
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
import "chartkick/chart.js";


// Imports internes
import { initSelect2 } from '../components/init_select2';
import { initMenuSelector } from "../components/menu_selector";
import { initArrayInput } from "../components/array_input";
import { initHEXModal2 } from "../components/hex_modal2";
import { initTableauHexSearchBar } from "../components/tableau_hex_search_bar";
import { initReducteur } from "../components/reducteur";
import { initBasicMultiple } from "../components/basic_multiple";
import { initDropdown } from "../components/dropdown";
import { initLineChart } from "../components/line_charts";
import { initBarChart } from "../components/barChart";
import { initStackedBarChart } from "../components/stackedBarChart";
import { initHalfDoughnutChart } from "../components/half_doughnut_chart";
import { initQuestionnaireBuilder } from "../components/questionnaire_builder";
import { initHEXTableauDynamique } from "../components/hexTableauDynamique";
import { initHEXTableauCounter } from "../components/hexTableauCounter";
import { initContentPreviewer } from "../components/content_previewer";
import { initGanttV1Chart } from "../components/gantt_v1_chart";
import { initFilter } from "../components/filter";
import { initGantt } from "../components/gantt";
import { initDevenirMembre } from "../components/devenir_membre";
import { initAlert } from "../components/alert";
import { initToggleEyes } from "../components/toggleEyes";
import { initFormsEnter } from "../components/formsEnter";
import { initDetectEndNavbar } from "../components/detectEndNavbar";
import { initDragAndDrop } from "../components/dragAndDropColonner";
import { initColonerCat } from "../components/colonerCat";
import { initCheckAverageClosing } from "../components/checkAverageClosing";
import { initPanel } from "../components/panel";
import { initConnection } from "../components/connection";
import { initDateEcheance } from "../components/date_echeance";
import { initCenterModal } from "../components/centerModal";
import { initTaskManager} from "../components/taskManager";
import {initClickableDiv} from "../components/clickableDiv";
import { initDropzone } from "../components/dropzone";
import { initMessages} from "../components/message";
import { initStartConversation} from "../components/start_conversation";
import { initConversations } from "../components/conversations_index";
import { initDiscussionIndex } from "../components/init_discussion_index";
import {initCreateContact} from "../components/initCreateContact";
import {initVerifyContact} from "../components/initVerifyContact";
import {initNavbar} from "../components/init_navbar";
import {initSidebar} from "../components/init_sidebar";
import {initTopbar} from "../components/init_topbar";
import {initCommandPalette} from "../components/command_palette";
import {initScopedSearchbar} from "../components/scoped_searchbar";
import {initDashFilters} from "../components/init_dash_filters";
import {initSearchableSelect} from "../components/searchable_select";

document.addEventListener('turbo:load', () => {
  initCreateContact();

  initSelect2();
  initToggleEyes();
  initMenuSelector();
  initArrayInput();
  initFilter();
  initDevenirMembre();
  initAlert();
  initPanel();
  initConnection();
  initHEXTableauDynamique();
  initGantt();
  initDragAndDrop();
  initHEXModal2();
  initTableauHexSearchBar();
  initReducteur();
  initClickableDiv();
  initBasicMultiple();
  initDropdown();
  initLineChart();
  initColonerCat();
  initCheckAverageClosing();
  initDetectEndNavbar();
  initBarChart();
  initStackedBarChart();
  initHalfDoughnutChart();
  initQuestionnaireBuilder();
  initHEXTableauCounter();
  initContentPreviewer();
  initGanttV1Chart();
  initContactForm();
  initTaskManager();
  initFormsEnter();
  initCenterModal();
  initBreakout();
  initDropzone();
  initDateEcheance();
  initMessages();
  initStartConversation();
  initConversations();
  initDiscussionIndex();
  initVerifyContact();
  initNavbar();
  initSidebar();
  initTopbar();
  initCommandPalette();
  initScopedSearchbar();
  initDashFilters();
  initSearchableSelect();

  // Réinitialiser tous les dropdowns Bootstrap après chaque navigation Turbo
  const dropdownElementList = document.querySelectorAll('[data-bs-toggle="dropdown"]');
  [...dropdownElementList].map(dropdownToggleEl => new bootstrap.Dropdown(dropdownToggleEl));

});


// Internal Import
import ImportWizard from "../bundles/Import/components/ImportWizard";



// Register components with ReactOnRails
ReactOnRails.register({
  ImportWizard
});


import { Application } from "@hotwired/stimulus";
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers";
import {initBreakout} from "../components/breakout";
import {initContactForm} from "../components/contactForm";


const application = Application.start();
// Explicit relative path: webpack's resolve.modules contains both
// app/javascript and node_modules, so a bare "controllers" string would
// resolve twice and every controller would register twice.
const context = require.context("../controllers", true, /_controller\.js$/);
application.load(definitionsFromContext(context));

